function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ContextmenuItem = /*#__PURE__*/function () {
  function ContextmenuItem(label, icon, menu) {
    var _this = this;

    _classCallCheck(this, ContextmenuItem);

    this.enabled = true;
    this.menu = menu;
    this.item = document.createElement('li');
    this.item.innerHTML = "<i class=\"".concat(icon, "\"></i> ").concat(label);
    this.item.addEventListener('click', function (event) {
      event.stopPropagation();

      if (typeof _this.onclick === 'function' && _this.enabled) {
        _this.onclick(_this.menu.context);

        _this.menu.hide();
      }
    });
  }

  _createClass(ContextmenuItem, [{
    key: "separator",
    value: function separator() {
      this.separator = true;
      this.item.classList.add('separator');
    }
  }, {
    key: "click",
    value: function click(onclick) {
      this.onclick = onclick;
      return this;
    }
  }, {
    key: "enable",
    value: function enable() {
      this.enabled = true;
      this.item.classList.remove('disabled');
      return this;
    }
  }, {
    key: "disable",
    value: function disable() {
      this.item.classList.add('disabled');
      this.enabled = false;
      return this;
    }
  }]);

  return ContextmenuItem;
}();

export { ContextmenuItem as default };